import {NgModule} from '@angular/core';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {RouterModule} from '@angular/router';
import {AcknowledgeOverlayModule} from '../components/acknowledge-overlay/acknowledge-overlay.module';
import {SharedModule} from '../shared.module';
import {ShareSegmentListPipe} from '../pipes/share-segment.pipe';
import {SegmentShareService} from '../segment-multi-share/segment-share.service';
import {SegmentCreateComponent} from './info/create/create.component';
import {SegmentDeleteButtonComponent} from './info/delete/segment-delete-button.component';
import {SegmentDeleteComponent} from './info/delete/delete.component';
import {SegmentEditButtonComponent} from './info/edit/segment-edit-button.component';
import {SegmentEditComponent} from './info/edit/edit.component';
import {ExportPreviewDialogComponent} from './list/export/export-preview-dialog.component';
import {SegmentGlobalToggleComponent} from './global-toggle/global-toggle.component';
import {SegmentInfoComponent} from './info/info.component';
import {
  GoogleDdpPriceActivationDialogComponent,
  SegmentInfoGoogleDdpComponent
} from './info/shared-targets-list/account-google-ddp/account-google-ddp.component';
import {
  GoogleDdpPriceDialogComponent
} from './info/shared-targets-list/account-google-ddp/google-ddp-price-dialog.component';
import {GoogleDdpPricesComponent} from './info/shared-targets-list/account-google-ddp/google-ddp-prices.component';
import {SegmentInfoAccountTtdComponent} from './info/shared-targets-list/account-ttd/account-ttd.component';
import {
  TtdSegmentPriceDialogComponent
} from './info/shared-targets-list/account-ttd/ttd-segment-price-dialog.component';
import {TtdSegmentPricesComponent} from './info/shared-targets-list/account-ttd/ttd-segment-prices.component';
import {AccountXandrComponent} from './info/shared-targets-list/account-xandr/account-xandr.component';
import {XandrBuyersComponent} from './info/shared-targets-list/account-xandr/xandr-buyers/xandr-buyers.component';
import {XandrPriceComponent} from './info/shared-targets-list/account-xandr/xandr-price/xandr-price.component';
import {SegmentInfoAccountComponent} from './info/shared-targets-list/account/account.component';
import {SegmentInfoAccountActiveAgentComponent} from './info/shared-targets-list/active-agent/active-agent.component';
import {SegmentInfoAccountListComponent} from './info/shared-targets-list/segment-info-account-list.component';
import {KeywordChipsComponent} from './info/keyword-chips/keyword-chips.component';
import {SegmentListComponent} from './list/list.component';
import {SegmentListTableComponent} from './list/table/table.component';
import {SegmentSearchComponent} from './list/search/search.component';
import {SegmentComponent} from './segment.component';
import {SegmentService} from './segment.service';
import {SegmentShareItemComponent} from './share/item/item.component';
import {SegmentShareItemTtdComponent} from './share/item/ttd/ttd.component';
import {SegmentShareComponent} from './share/share.component';
import {SegmentRemoveShareDialogComponent} from './share/remove-share-dialog.component';
import {SegmentValidationFormComponent} from './info/validation/form/form.component';
import {SegmentValidationActions} from './info/validation/validation.actions';
import {SegmentValidationComponent} from './info/validation/validation.component';
import {SegmentValidationService} from './info/validation/validation.service';
import {AccountPubmaticComponent} from './info/shared-targets-list/account-pubmatic/account-pubmatic.component';
import {
  AccountPubmaticEditWrapperComponent
} from './info/shared-targets-list/account-pubmatic/account-pubmatic-edit-wrapper.component';
import {BuyersEditComponent} from './info/shared-targets-list/account-pubmatic/buyers-edit/buyers-edit.component';
import {SharedAccountsRowComponent} from './list/table/shared-accounts-row/shared-accounts-row.component';
import {
  SharedAccountsIconComponent
} from './list/table/shared-accounts-row/shared-accounts-icon/shared-accounts-icon.component';
import {ParentSegmentComponent} from './info/parent-segment/parent-segment.component';
import {TreeTableComponent} from './list/tree-table/tree-table.component';
import {TaxonomyDropdownComponent} from '../taxonomy/taxonomy-dropdown/taxonomy-dropdown.component';
import {SegmentAuditLogsComponent} from './info/segment-audit-log/segment-audit-logs.component';
import {AuditLogsModule} from '../audit-logs/audit-logs.module';
import {ExportPricesDialogComponent} from './list/export-prices/export-prices-dialog/export-prices-dialog.component';
import {CustomConfigurationModule} from '../custom-configuration/custom-configuration.module';
import {
  BulkDeleteSegmentsDialogComponent
} from './list/bulk-delete-segments-dialog/bulk-delete-segments-dialog.component';
import {TtdModule} from '../ttd/ttd.module';

/** Redux Actions. */
const APP_REDUX_ACTIONS = [
  SegmentService,
  SegmentShareService,
  SegmentValidationActions,
  SegmentValidationService
];

@NgModule({
  declarations: [
    SegmentComponent,
    SegmentListComponent,
    SegmentInfoComponent,
    SegmentShareComponent,
    SegmentCreateComponent,
    ShareSegmentListPipe,
    SegmentDeleteButtonComponent,
    SegmentEditButtonComponent,
    SegmentEditComponent,
    SegmentGlobalToggleComponent,
    SegmentInfoAccountComponent,
    SegmentInfoAccountTtdComponent,
    TtdSegmentPricesComponent,
    TtdSegmentPriceDialogComponent,
    SegmentInfoGoogleDdpComponent,
    GoogleDdpPriceDialogComponent,
    GoogleDdpPriceActivationDialogComponent,
    GoogleDdpPricesComponent,
    SegmentRemoveShareDialogComponent,
    SegmentValidationComponent,
    SegmentInfoAccountListComponent,
    SegmentValidationFormComponent,
    SegmentSearchComponent,
    SegmentShareItemComponent,
    SegmentShareItemTtdComponent,
    SegmentInfoAccountActiveAgentComponent,
    SegmentDeleteComponent,
    AccountXandrComponent,
    XandrPriceComponent,
    XandrBuyersComponent,
    KeywordChipsComponent,
    ExportPreviewDialogComponent,
    AccountPubmaticComponent,
    AccountPubmaticEditWrapperComponent,
    BuyersEditComponent,
    SegmentListTableComponent,
    SharedAccountsRowComponent,
    SharedAccountsIconComponent,
    ParentSegmentComponent,
    TreeTableComponent,
    TaxonomyDropdownComponent,
    SegmentAuditLogsComponent,
    ExportPricesDialogComponent,
    BulkDeleteSegmentsDialogComponent
  ],
  imports: [
    SharedModule,
    MatPaginatorModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    RouterModule,
    MatProgressSpinnerModule,
    AcknowledgeOverlayModule,
    AuditLogsModule,
    CustomConfigurationModule,
    TtdModule
  ],
  exports: [
    SegmentInfoAccountActiveAgentComponent,
    SegmentInfoGoogleDdpComponent,
    GoogleDdpPriceDialogComponent,
    GoogleDdpPricesComponent,
    AccountXandrComponent,
    KeywordChipsComponent,
    SegmentInfoAccountTtdComponent,
    AccountPubmaticComponent,
    TaxonomyDropdownComponent
  ],
  providers: [
    APP_REDUX_ACTIONS
  ],
  bootstrap: [SegmentComponent]
})
export class SegmentModule {
}
